// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Mbpa","toggle":"styles_toggle__1JRqi","preview":"styles_preview__2V_3a"};